export default __webpack_public_path__ + "static/media/Ndianabasi Archibong.110bfa90.jpg";